/**
 * Last line of defence (docs/10 M17: never a blank screen). A render error
 * anywhere below shows a recovery card with the message, a reload, and a
 * "start fresh" that clears local data — the usual cause of a crash after
 * an update is a stale stored shape, not the network.
 */
import { Component, type ReactNode } from 'react';
import { store } from './storage.js';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('[surge] render error', error);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="app">
        <div className="card" style={{ marginTop: 48, gap: 12 }}>
          <h1 className="title">Something went wrong</h1>
          <p className="sub">Surge hit an error drawing this screen. Reloading usually fixes it.</p>
          <p className="small muted" style={{ wordBreak: 'break-word' }}>{this.state.error.message}</p>
          <button className="btn primary" onClick={() => window.location.reload()}>Reload</button>
          <button className="btn secondary" onClick={() => { store.purgeAll(); window.location.reload(); }}>
            Start fresh (clears saved places and settings on this phone)
          </button>
        </div>
      </div>
    );
  }
}
